<template>
    <div class="section" dir="rtl">
        <div class="container">
            <div class="breadcrumb mb-10 text-bold" id="biography" > {{  $t('header.activities.title') }} > {{ $t('events.titlePage') }}</div>
        </div>
    </div>
    <div class="container mt-5 text-center mb-5" dir="rtl">
        <div class="headPage">
            السلطة العليا للشفافية والوقاية من الفساد ومكافحته هي مؤسسة وطنية مستقلة، تهدف إلى تعزيز النزاهة ومحاربة الفساد من خلال الرقابة، التحسين، والتبليغ.
        </div>
        <div class="shadow-lg p-3 mb-5 bg-body rounded details_event">
            <span></span>
            <h5>{{ events.subtitle }}</h5>
            <img :src="url_back +'events/images/' + events.image" class="img-fluid img-thumbnail" alt="" style="margin-bottom: 15px"><br>
            <!--<span class="date_event">ولاية مستغانم - يومي 14-15 أكتوبر 2025</span>-->
            <div class="text-center description_event">
                <h6>
                    {{ events.title }}
                </h6>
                <h6>
                    {{ events.content }}
                </h6>
            </div>
        </div>
        <div class="shadow-lg p-3 mb-5 bg-body rounded details_event">
            <span></span>
            <h5>معلومات الإتصال</h5>
            <div class="row">
                <div class="col-md-3">
                    <div class="card text-center">
                        <div class="card-header">
                            <img :src="'/images/icons/phone_new.png'" alt=""><br><br>
                            <span>الهاتف</span><br>
                            <a href="tel:04 73 48 23 (0) 213+" style="text-decoration: none!important; color: black">
                                04 73 48 23 (0) 213+
                            </a>
                            <!--<span>04 73 48 23 (0) 213+</span>-->
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card text-center">
                        <div class="card-header">
                            <img :src="'/images/icons/fax_new.png'" alt=""><br><br>
                            <span>الفاكس</span><br>
                            <span>04 73 48 23 (0) 213+</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card text-center">
                        <div class="card-header">
                            <img :src="'/images/icons/mail.png'" alt=""><br><br>
                            <span>البريد الالكتروني</span><br>
                            <a href="mailto:page_evenement@hatplc.dz" style="text-decoration: none!important; color: black">
                                page_evenement@hatplc.dz
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card text-center">
                        <div class="card-header">
                            <img :src="'/images/icons/internet.png'" alt=""><br><br>
                            <span>الموقع الالكتروني</span><br>
                            <a href="www.hatplc.dz" style="text-decoration: none!important; color: black;">
                                www.hatplc.dz
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="shadow-lg p-3 mb-5 bg-body rounded details_event">
            <span><h5><img :src="'/images/icons/file.png'" alt=""> الوثائق الرسمية</h5></span>
            <a v-for="doc in event_docs" :href="url_back +'events/file/' + doc.file_name" target="_blank" class="btn btn-success" style="background-color: #254C31!important; margin: 15px 15px">
                {{ doc.file_label }}
            </a>
        </div>
        <!--<div class="shadow-lg p-3 mb-5 bg-body rounded details_event">-->
            <!--<span><h5><img :src="'/images/icons/travel.png'" alt=""> الموقع الجغرافي</h5></span>-->
            <!--&lt;!&ndash;<a href="https://maps.app.goo.gl/zasCTQChCty6Z3ai6" target="_blank" style="text-decoration: none!important;">&ndash;&gt;-->
                <!--&lt;!&ndash;<h5> مقر ولاية مستغانم، الجزائر</h5>&ndash;&gt;-->
            <!--&lt;!&ndash;</a>&ndash;&gt;-->
            <!--<a :href="events.location_maps" target="_blank" style="text-decoration: none!important;">-->
                <!--<img :src="url_back +'events/images/' + events.image_maps" class="img-fluid img-thumbnail" alt="">-->
            <!--</a>-->
            <!--<div class="mt-4 mb-2">-->
                <!--<a :href="events.location_maps" target="_blank" class="btn-success" style="background-color: #254C31!important; text-decoration: none!important; padding: 10px; color: white">-->
                    <!--فتح في Google Maps-->
                <!--</a>-->
            <!--</div>-->
        <!--</div>-->
        <div class="shadow-lg p-3 mb-5 bg-body rounded details_event">
            <span><h5> شاركنا رأيك</h5></span>
            <div class="mt-2 mb-4 text-center space_alert d-none">
                <ul class="mb-0" style="list-style-type: none">
                    <li v-for="(error, index) in errors" :key="index">
                        {{ error }}
                    </li>
                </ul>
            </div>
            <form @submit.prevent="saveFeedback" novalidate>
                <fieldset>
                    <div class="row">
                        <div class="col-md-12">
                            <input type="text" v-model="request.pseudo" class="form-control" placeholder="الاسم الكامل" required>
                        </div>
                        <br><br>
                        <div class="col-md-12">
                            <input type="email" v-model="request.email" class="form-control" placeholder="البريد الإلكتروني" required>
                        </div>
                        <br><br>
                        <div class="col-md-12">
                            <textarea v-model="request.message" cols="30" rows="5" id="message" class="form-control" placeholder="ملاحظاتك أو اقتراحاتك" required></textarea>
                        </div>
                    </div>
                    <div class="recaptcha mt-3" :dir="rtl">
                        هذا الموقع محمي بواسطة reCAPTCHA و Google
                        <a href="https://policies.google.com/privacy"  target="_blank" rel="noopener noreferrer">سياسة الخصوصية</a> و
                        <a href="https://policies.google.com/terms"  target="_blank" rel="noopener noreferrer">شروط الخدمة</a> التقدم.
                    </div>
                    <div class="mt-3">
                        <button class="btn btn-success fw-bold" style="background-color: #254C31!important;">
                            إرسال
                        </button>
                    </div>
                </fieldset>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import moment from 'moment';
    export default {
        name: "events",
        data: function () {
            const lang = localStorage.getItem('lang') || 'ar';
            return {
                events:{},
                event_docs:Array,
                request:{},
                pseudo:'',
                email:'',
                message:'',
                errors:[],
                url_back: process.env.VUE_APP_ROOT_API +'uploads/'
            }
        },
        created(){},
        computed: {},
        mounted(){
            this.getEvent();
            this.getEventDocs();
        },
        methods:{
            async saveFeedback(){
                this.errors = [];
                $(".space_alert").removeClass('d-none');
                $(".space_alert").removeClass('alert-danger');
                $(".space_alert").removeClass('alert-success');

                if(!this.request.pseudo){
                    $(".space_alert").addClass('alert alert-danger');
                    this.errors.push("pseudo is required");
                    setTimeout(function() {
                        $(".space_alert").addClass('d-none');
                    }, 10000);
                }
                if(!this.request.email){
                    $(".space_alert").addClass('alert alert-danger');
                    this.errors.push("Email is required");
                    setTimeout(function() {
                        $(".space_alert").addClass('d-none');
                    }, 10000);
                }
                if(!this.request.message){
                    $(".space_alert").addClass('alert alert-danger');
                    this.errors.push("Message is required");
                    setTimeout(function() {
                        $(".space_alert").addClass('d-none');
                    }, 10000);
                }
                if(!this.errors.length){
                    this.$recaptchaLoaded().then(() => {
                        this.$recaptcha("login").then((token) => {
                            let formData = new FormData();
                            formData.append('pseudo', this.request.pseudo);
                            formData.append('email', this.request.email);
                            formData.append('message', this.request.message);

                            formData.append('token', token);
                            // console.log('token is: '+token);
                            let url_store_feedback = process.env.VUE_APP_ROOT_API + "api/save_feedback";
                            axios.post(url_store_feedback, formData).then((response) => {
                                console.log(response);
                                if(response.data.code ===200){
                                    this.request.pseudo  = '';
                                    this.request.email   = '';
                                    this.request.message = '';
                                    $(".space_alert").addClass('alert alert-success');
                                    this.errors.push(response.data.message);
                                    setTimeout(function() {
                                        $(".space_alert").addClass('d-none');
                                    }, 7000);

                                }else if(response.data.code ===303) {
                                    $(".space_alert").addClass('alert alert-danger');
                                    this.errors.push(response.data.message);
                                    setTimeout(function() {
                                        $(".space_alert").addClass('d-none');
                                    }, 7000);
                                }
                            }).catch(error =>{
                                this.errors.push(error.response);
                            })
                        });
                    });
                }
            },

            async getEvent(){
                let event_id = this.$route.params.id;
                if(!event_id){
                    this.$router.replace({ path: '/PageNotFound' });
                }else {
                    if(event_id == 1){

                        let url = process.env.VUE_APP_ROOT_API + `api/events/${this.$route.params.id}`;
                        await axios.get(url).then(response =>{
                            this.events = response.data.events;
                            // console.log(this.events);
                        }).catch(error => {
                            console.log(error);
                        });
                    }
                    else {
                        this.$router.replace({ path: '/PageNotFound' });
                    }
                }
            },

            async getEventDocs(){
                let event_id = this.$route.params.id;
                if(!event_id){
                    this.$router.replace({ path: '/PageNotFound' });
                }else{
                    if(event_id == 1){

                        let url = process.env.VUE_APP_ROOT_API + `api/event_docs/${this.$route.params.id}`;
                        await axios.get(url).then(response =>{
                            this.event_docs = response.data.event_docs;
                            console.log(this.event_docs);
                        }).catch(error => {
                            console.log(error);
                        });
                    }
                    else {
                        this.$router.replace({ path: '/PageNotFound' });
                    }
                }
            }
        }
    }
</script>

<style scoped>
    ul.no-bullets {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
    .mot_president{
        color: rgba(50, 54, 57, 0.83);
    }
    .nav-link{
        color: rgba(80, 84, 87, 0.8) !important;
    }
    .active{
        color: rgba(28, 28, 28, 0.96)!important;
    }
    .section {
        display: flex;
        align-items: center;
        font-size: var(--xs-font-size);
        font-weight: bold;
        background: var(--secondary-background-color);
        padding: calc(7/16 * var(--default-size-unit)) calc((100vw - 1920px)/2 +  var(--body-padding));
        border-top: var(--input-border);
        border-bottom: var(--input-border);
        font-family: Cairo,sans-serif;
    }
    .breadcrumb{
        text-decoration: none!important;
        margin: 0;
        color: #37414D;
        font-family: Cairo,sans-serif!important;
    }
    .title {
        width: 100%;
        display: flex;
        align-items: center;
        font-size: var(--l-font-size);
        font-weight: 700;
    }
    .title::before {
        content: ' ';
        display: block;
        -webkit-margin-end: var(--default-size-unit);
        margin-inline-end: var(--default-size-unit);
        width: calc(35/16 * var(--default-size-unit));
        height: calc(8/16 * var(--default-size-unit));
        background: var(--primary-text-color);
        min-width: calc(35/16 * var(--default-size-unit));
    }
    .back-gray{
        background-color: #E7E9EB;
        padding: 15px 15px;
    }
    .back-gray p{
        line-height: 200%;
    }
    .headPage{
        text-align: center!important;
        color: #254C31;
        font-size: 16px;
    }
    .details_event{
        margin-top: 30px;
    }
    .details_event h5{
        color: #254C31;
    }
    .date_event{
        font-size: 18px;
        font-weight: bold;
        color: #254C31;
    }
    .description_event{
        margin-top: 20px;
    }
    .description_event h6{
        font-size: 16px;
        color: rgba(57, 57, 57, 0.8);
    }
</style>